


































import Vue from "vue";
import uploader from '../../common/components/uploader.vue';
import { WorkRecordServiceProxy } from "@/service-proxies/app-v2/work-record.service-proxies";
const workRecordService = new WorkRecordServiceProxy();

export default Vue.extend({
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {uploader},
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      rules: {
        comment: [
          { required: true, message: this.$t('page_ops_work_record_comment_required'), trigger: 'blur' },
        ]
      },
      businessKey: "",
      taskId: "",
      form: {
        comment: "",
      },
      imageList: [],
      videoList: []
    };
  },
  methods: {
    async initData(record) {
      this.businessKey = record.businessKey;
      this.taskId = record.taskId;
    },
    getImageList(data){
      this.imageList = data
    },
    getVideoList(data){
      this.videoList = data
    },
    save() {
      this.$refs.commentForm.validate(valid => {
        if (valid) {
          const params: any = {
          commentMessage: this.form.comment,
          businessKey: this.businessKey,
          taskId: this.taskId,
          attachmentList: [...this.imageList,...this.videoList]
        };
        workRecordService.commentsAdd(params).then((res) => {
          this.checkedList = [];
          this.$message.success(this.$t("success"));
          this.$emit("cancel", true);
          this.form.comment = '';
          this.imageList= [];
          this.videoList = [];
        });
        } else {
          return false;
        }
      });
    },
  },
});
